import { CommonButton } from 'components/Button'
import { ChangeEvent, Dispatch, useRef } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useAppDispatch } from 'app/hooks'
import { uploadFileThunk } from './aboutThunks'
import { CompanyImageUploadInput } from './styles'
import { AboutMessages } from './messages'

function uploadFile(
  domainId: string,
  dispatch: ReturnType<typeof useAppDispatch>,
  onProgress: Dispatch<number | undefined>
) {
  return async (e: ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target
    if (files && files.length) {
      dispatch(uploadFileThunk(domainId, onProgress, files))
    }
  }
}

interface CompanyImageUploaderProps {
  onProgress: Dispatch<number | undefined>
}

export function CompanyImageUploader({
  onProgress,
}: CompanyImageUploaderProps) {
  const {
    params: { rootDomainId },
  } = useRouteMatch<{ rootDomainId: string }>()
  const { formatMessage } = useIntl()
  const dispatch = useAppDispatch()

  const inputFile = useRef<HTMLInputElement | null>(null)

  function handleImageChangeClick() {
    inputFile.current?.click()
  }

  return (
    <>
      <CommonButton variant="secondary" onClick={handleImageChangeClick}>
        {formatMessage(AboutMessages.companyChangeImage)}
      </CommonButton>
      <CompanyImageUploadInput
        type="file"
        id="company-image-file"
        ref={inputFile}
        accept="image/*"
        onChange={uploadFile(rootDomainId, dispatch, onProgress)}
      />
    </>
  )
}
